var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { Select } from 'ziphy-web-shared/basic/lib/forms/fields';
import { confirmAction } from '@library/utils/actionConfirmator/ActionConfirmator';
import { getLinkByPractice } from '@helpers/byPractice';
import { $notes } from '../../Notes.store';
import styles from './TopBar.module.scss';
const TopBar = ({ className }) => {
    const { t } = useTranslation();
    const encounter = $notes.encounter;
    function handleSwitchLayout(layoutId) {
        if (layoutId === $notes.layout.layoutId)
            return;
        confirmAction('customAlert', {
            data: {
                title: t('confirmator.notes_switch_layout.title'),
                message: t('confirmator.notes_switch_layout.message'),
            },
            callback: () => __awaiter(this, void 0, void 0, function* () {
                yield $notes.switchLayout({ layoutId });
            }),
            skip: !$notes.layout.blocked,
        });
    }
    if (!$notes.layout) {
        return _jsx(_Fragment, {});
    }
    const mdToolbox = getLinkByPractice('mdToolbox', encounter.practiceId);
    const parachuteHealth = getLinkByPractice('parachuteHealth', encounter.practiceId);
    return (_jsxs("div", Object.assign({ className: classNames(styles.wrapper, className) }, { children: [_jsx(Select, { field: {
                    value: $notes.layout.layoutId,
                    onChange: (value) => handleSwitchLayout(value),
                }, mode: ['sm', 'fw-600'], items: $notes.availableLayouts, disabled: !$notes.isEditable, className: styles.layoutsSelect }), _jsxs("div", Object.assign({ className: styles.links }, { children: [mdToolbox && (_jsx("a", Object.assign({ href: mdToolbox.link, target: "_blank", rel: "noreferrer", className: styles.link }, { children: t('label.md_toolbox') }))), parachuteHealth && (_jsx("a", Object.assign({ href: parachuteHealth.link, target: "_blank", rel: "noreferrer", className: styles.link }, { children: t('label.parachute_health') })))] }))] })));
};
export default observer(TopBar);
